<template>
  <div class="">
    <ais-toggle-refinement
      v-for="(filter, index) in filters"
      :key="filter.attribute+'-'+index"
      :attribute="filter.attribute"
      :label="filter.title"
    >
      <div
        slot-scope="{ value, refine }"
      >
        <v-switch
          v-model="value.isRefined"
          @input="refine(value)"
          hide-details
          color="kazan"
        >
          <template v-slot:label>
            {{filter.title}}
          </template>
        </v-switch>
      </div>
    </ais-toggle-refinement>
  </div>
</template>

<script>

export default {
  name: 'AlgoliaSwitchFilters',
  props: {
    filters: Array
  }
}
</script>

<style lang="scss" scoped>

</style>
